export default __webpack_public_path__ + "assets/images/7bfbae16f8e09560417edebddc0f0c64.png";